import { useQuery } from "@tanstack/react-query";
import { axiosCompanyInstance } from "src/config/axios";
import { UserRoles } from "../../types/UserRoles";
import { AutocompleteList } from "src/utils/response";

export const RQ_USER_AUTOSUGEST_KEY = "USER_AUTOSUGEST_KEY";

export const useUserAutosugest = (input: string, hasFullAccess?: boolean, role?: UserRoles) => {
    return useQuery({
        queryKey: [RQ_USER_AUTOSUGEST_KEY, input, hasFullAccess, role],
        queryFn: async (): Promise<AutocompleteList> => {
            if (input) {
                const resp = await axiosCompanyInstance.get(`autocomplete/company-user`, {
                    params: { input, hasFullAccess: hasFullAccess ? 1 : 0, role },
                });

                return resp?.data || null;
            }
            return [];
        },
    });
};
